export enum TourInfoScreenEnum {
  Home = 1,
  QAi = 2,
  ExpertNetwork = 3,
  ExcluisveDeals = 4,
  BackgroundChecks = 5,
  AgenciesCollectives = 6,
  Resources = 7,
  Network = 8,
  Mentors = 9,
  Survey = 10,
  Discounts = 11,
  DocumentReview = 12,
}
